import { Box, Typography } from "@mui/material";
import { Fragment } from "react";

export default function GenersBreadCrumb({ breadcrumb, setBreadcrumb, setBreadcrumbClicked }) {

  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      {breadcrumb?.map((crumb, idx) => (
        <Fragment key={idx}>
          <Typography
            variant="body1"
            fontWeight={idx === breadcrumb?.length - 1 ? "bold" : "normal"}
            sx={{ cursor: idx !== breadcrumb?.length - 1 ? "pointer" : "default", color: "#000000" }}
            onClick={() => {
              //console.log("idx : ",idx)
              //console.log("breaccrumb length : ",breadcrumb.length-1)
              if (idx !== breadcrumb?.length - 1) {
                setBreadcrumb(breadcrumb?.slice(0, idx + 1));
                setBreadcrumbClicked(true)
              }
            }}
          >
            {crumb?.title}
          </Typography>
          {idx !== breadcrumb?.length - 1 && (
            <Typography variant="body1" sx={{ mx: 1 }}>
              {'>'}
            </Typography>
          )}
        </Fragment>
      ))}
    </Box>
  );
}